import cookie from "../../modules/cookie";

(function () {
    if (document.querySelectorAll(".js-header").length > 0) {
        const header = {
            store: {
                contentContainer: document.getElementsByTagName("body")[0],
                mainLinks: document.querySelectorAll(".js-megamenu-toggle.header__link--wrapper__children"),
                headerLinks: document.querySelectorAll(".js-header-link"),
                languageLinks: document.querySelectorAll(".js-language-toggle"),
                subMenuExpandItems: document.querySelectorAll(".js-submenu-expand .card__hasChildren"),
                subMenuChildren: document.querySelectorAll(".js-submenu-children"),
                megaMenuIsExpanded: false,
                languagePanelIsExpanded: false,
                megaMenuContent: document.querySelectorAll(".megamenu_content"),
                headerHeight: 131
            },
            init: () => {
                header.removePresetClasses(header.store.megaMenuContent);
                if (window.innerWidth > 1047) {
                    header.hideMenuOnScroll();
                }
                header.onResize();
                header.mainLinkInteraction();
                header.clickOnLanguageSelector();
                header.closeLanguageSelector();
                header.detectActiveTopLink();
                header.toogleQuickLanguageSelect();
                header.navigateLanguage();
                header.OpenContryselectorPopup();
                header.triggerPhonePanel();
                header.registerResize();
                header.changeChevronDownColor();
                header.expandMobileMegaMenu();
                header.closeMegaMenuOnClick();
                header.MegaMenuAccessibility();
            },
            onResize: () => {
                window.addEventListener("resize", () => {
                    clearTimeout(window.resizedFinished);
                    window.resizedFinished = setTimeout(function () {
                        if (window.innerWidth < 800) {
                            header.toggleMobileMenu();
                            header.expandMobileMegaMenu();
                            header.expandSubmenus();
                        }
                        if (window.innerWidth > 800) {
                            const mobilMenuHeader = document.querySelectorAll(
                                ".menu__mobile--expanded"
                            );
                            mobilMenuHeader.forEach((element) => {
                                element.classList.remove("menu__mobile--expanded");
                            });
                        }
                        header.changeChevronDownColor();
                    }, 250);
                });
            },

            mainLinkInteraction: () => {
                header.store.headerLinks.forEach((headerLink) => {
                    if (headerLink.closest(".js-megamenu-toggle").querySelectorAll(".megamenu-icon").length > 0) {
                        headerLink.closest(".js-megamenu-toggle").querySelector(".megamenu_labels").classList.add('has-icons')
                    }
                });

                if (window.innerWidth < 800) {
                    header.toggleMobileMenu();
                    header.expandSubmenus();
                } else {
                    header.checkForKeyPress();

                    header.store.mainLinks.forEach((mainLink) => {

                        const background = document.getElementById("megamenu_background");
                        const overlay = document.getElementById("megamenu_overlay");

                        let hoverInTimeout;
                        let hoverOutTimeout;

                        mainLink.addEventListener("mouseenter", function (e) {
                            clearTimeout(hoverOutTimeout);

                            hoverInTimeout = setTimeout(() => {
                                header.showMegaMenu(e.target);

                                const height = e.target.lastElementChild.offsetHeight + header.store.headerHeight + "px";

                                if (background && overlay) {
                                    background.style.height = height;
                                    overlay.style.height = "100%";
                                }

                            }, 300);

                        });

                        mainLink.addEventListener("mouseleave", function (e) {
                            clearTimeout(hoverInTimeout);

                            hoverOutTimeout = setTimeout(() => {
                                
                                const {
                                    clientX: x,
                                    clientY: y
                                } = e
                                const elementMouseIsOver = document.elementFromPoint(x, y);

                                if (!elementMouseIsOver || !elementMouseIsOver.closest('.header__link--wrapper__children .expanded-mega-menu')) {
                                    background.style.height = header.store.headerHeight + "px";
                                    overlay.style.height = "0%";
                                    header.hideMegaMenu(e.target);
                                }
                            }, 300);

                        });
                    });

                    header.store.headerLinks.forEach((headerLink) => {
                        headerLink.addEventListener("focus", function (e) {
                            const elem = e.target.closest(".js-megamenu-toggle");
                            const openPanel = document.querySelector(
                                ".js-megamenu-toggle.active"
                            );

                            if (openPanel !== null) {
                                header.hideMegaMenu(openPanel);
                            }

                            e.target.onkeydown = function (event) {
                                if (event.keyCode == 39) {
                                    elem.focus();
                                    header.showMegaMenu(elem);
                                }

                                if (event.keyCode == 37) {
                                    elem.blur();
                                    header.hideMegaMenu(elem);
                                }
                            };
                        });
                    });

                    header.store.subMenuChildren.forEach((subMenuChild) => {
                        subMenuChild.addEventListener("focus", function (e) {
                            e.target.onkeydown = function (event) {
                                if (event.keyCode == 39) {
                                    e.target.closest(".submenu__item").classList.add("active");
                                }

                                if (event.keyCode == 37) {
                                    e.target.closest(".submenu__item").classList.remove("active");
                                }
                            };
                        });
                    });

                    header.expandSubmenus();
                }
            },
            expandSubmenus: () => {
                header.store.subMenuExpandItems.forEach((subMenuExpandItem) => {

                    subMenuExpandItem.addEventListener("click", (e) => {
                        if (!e.target.classList.contains("active")) {
                            const activeSubMenus = document.querySelectorAll(".submenu__item.active");
                            const activeSubMenusLinks = document.querySelectorAll(".submenu__item a.active");

                            if (activeSubMenus !== null) {
                                activeSubMenus.forEach((activeSubMenu) => {
                                    activeSubMenu.classList.remove("active");
                                    activeSubMenu.querySelector(".megamenu-expand-icon").classList.remove("active");
                                });

                                activeSubMenusLinks.forEach((activeSubMenusLink) => {
                                    activeSubMenusLink.classList.remove("active");
                                });

                            }

                            e.preventDefault();

                            const headerHeight = e.target.closest(".megamenu_labels").querySelector(".megamenu-header-text").offsetHeight;
                            const columnHeight = e.target.closest(".column").offsetHeight;
                            const subMenuHeight = e.target.closest(".submenu__item").querySelector("ul").offsetHeight;

                            const newHeight = headerHeight + columnHeight + subMenuHeight;
                            const oldHeight = e.target.closest(".megamenu_labels").offsetHeight;

                            if (newHeight > oldHeight) {
                                const backgroundHeight = newHeight + header.store.headerHeight + 38 + "px"; // new height + header + margins
                                document.getElementById("megamenu_background").style.height = backgroundHeight;
                            } else {
                                const backgroundHeight = oldHeight + header.store.headerHeight + 48 + "px"; // old height + header + margins
                                document.getElementById("megamenu_background").style.height = backgroundHeight;
                            }

                            setTimeout(() => {
                                e.target.classList.toggle("active");
                                e.target.closest(".submenu__item").querySelector(".megamenu-expand-icon").classList.toggle("active");
                                e.target.closest(".submenu__item").classList.toggle("active");
                            }, 300);

                            e.stopImmediatePropagation();
                        }
                    });

                    subMenuExpandItem.closest(".submenu__item").querySelector(".megamenu-expand-icon").addEventListener("click", (e) => {
                        if (e.target.classList.contains("active")) {
                            e.target.classList.toggle("active");
                            subMenuExpandItem.classList.toggle("active");
                            e.target.closest(".submenu__item").classList.toggle("active");

                            const height = e.target.closest(".header__sub--wrapper").offsetHeight + header.store.headerHeight + "px";
                            document.getElementById("megamenu_background").style.height = height;
                        } else {
                            subMenuExpandItem.click();
                        }
                    });
                });
            },
            clickOnLanguageSelector: () => {
                const panel = document.getElementById("country-selector");
                if (window.location.hash == "#select-country") {
                    panel.classList.add("active");
                    panel.setAttribute("aria-expanded", "true");

                    header.store.languagePanelIsExpanded = true;
                }

                header.store.languageLinks.forEach((languageLink) => {
                    languageLink.addEventListener("click", function () {
                        panel.classList.add("active");
                        panel.setAttribute("aria-expanded", "true");

                        header.store.languagePanelIsExpanded = true;
                    });
                });
            },
            closeLanguageSelector: () => {
                const panel = document.getElementById("country-selector");

                if (panel !== null) {
                    panel.addEventListener("click", (e) => {
                        if (
                            e.target.parentElement.classList.contains("header__country") ||
                            e.target.classList.contains("country-selector__close")
                        ) {
                            panel.classList.remove("active");
                            panel.setAttribute("aria-expanded", "false");

                            header.store.languagePanelIsExpanded = false;
                        }
                    });
                }
            },
            checkForKeyPress: () => {
                document.onkeydown = function (e) {
                    if (header.store.languagePanelIsExpanded) {
                        if (e.keyCode == 27) {
                            const panel = document.getElementById("country-selector");

                            panel.classList.remove("active");
                            panel.setAttribute("aria-expanded", "false");
                        }
                    }

                    if (e.keyCode == 9) {
                        if (document.activeElement.classList.contains("skip-to-main")) {
                            document.getElementsByClassName("js-header")[0].style.top = "0px";
                        }
                    }
                };
            },
            removePresetClasses: (ref) => {
                ref.forEach((element) => {
                    const imageBlock = element.querySelector(".image-with-text-block");

                    if (imageBlock) {
                        imageBlock.classList.add("content-container");
                        imageBlock.classList.remove("block", "grid__gap", "grid", "image-with-text-block");
                        imageBlock.querySelector("img")?.removeAttribute("loading");

                        const jsImageBlock = element.querySelector(".js-image-with-text-block");
                        if (jsImageBlock) {
                            jsImageBlock.classList.remove("js-image-with-text-block");
                        }
                    }
                });
            },
            showMegaMenu: (ref) => {
                const iconButton = ref.querySelector(".js-megamenu-toggle .link__inner button");
                const subPanel = ref.querySelector(".header__sub--wrapper");
                const headerWrapper = document.getElementsByClassName("js-header")[0];
                const container = ref.querySelectorAll(
                    ".megamenu_content .content-container"
                );
                if (container.length > 1) {
                    ref
                        .querySelector(".header__sub--wrapper")
                        .classList.add("double-vertical");
                } else {
                    const preamble = ref.querySelector(".content-container .col.text");
                    if (preamble) {
                        const pmid = preamble.querySelector(".block--preamble");
                        if (pmid.textContent.trim().length > 250) {
                            ref
                                .querySelector(".header__sub--wrapper")
                                .classList.add("landscape");
                        }
                    }
                }

                if (iconButton !== null) {
                    iconButton.setAttribute("aria-expanded", "true");
                }

                if (subPanel !== null) {
                    headerWrapper.style.overflow = "initial";
                    ref.classList.add("active");
                    subPanel.style.display = "block";

                    //Edge detection on expanded submenu
                    const subPanelPosition = subPanel.getBoundingClientRect();
                    if (subPanelPosition.right > window.innerWidth) {
                        subPanel.style.right = 0;
                    } else {
                        subPanel.style.left = 0;
                    }

                    subPanel.style.top = "100%";
                    subPanel.style.opacity = 1;
                    subPanel.setAttribute("aria-expanded", "true");

                    header.store.megaMenuIsExpanded = true;
                    header.store.contentContainer.classList.add("megamenu__expanded");
                }
            },
            hideMegaMenu: (ref) => {
                const iconButton = ref.querySelector(".js-megamenu-toggle .link__inner button");
                const subPanel = ref.querySelector(".header__sub--wrapper");

                if (iconButton !== null) {
                    iconButton.setAttribute("aria-expanded", "false");
                }

                if (subPanel != null) {
                    subPanel.style.top = "-100vh";
                    subPanel.style.opacity = 0;
                    subPanel.style.display = "none";
                    subPanel.style.left = "";
                    subPanel.style.right = "";
                    subPanel.setAttribute("aria-expanded", "false");

                    ref.classList.remove("active");
                }

                const activeSubMenus = document.querySelectorAll(".submenu__item.active");
                const activeSubMenusLinks = document.querySelectorAll(".submenu__item a.active");

                if (activeSubMenus !== null) {
                    activeSubMenus.forEach((activeSubMenu) => {
                        activeSubMenu.classList.remove("active");
                        const megamenuExpandIcon = activeSubMenu.querySelector(".megamenu-expand-icon");
                        if (megamenuExpandIcon) {
                            megamenuExpandIcon.classList.remove("active");
                        }
                    });

                    activeSubMenusLinks.forEach((activeSubMenusLink) => {
                        activeSubMenusLink.classList.remove("active");
                    });
                }

                header.store.megaMenuIsExpanded = false;
                header.store.contentContainer.classList.remove("megamenu__expanded");
            },
            MegaMenuAccessibility: () => {
                const iconButtons = document.querySelectorAll(".js-megamenu-toggle .link__inner button");

                iconButtons?.forEach((iconButton) => {
                    iconButton?.addEventListener('keydown', (event) => {
                        if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault();
                            const ref = iconButton.closest('.js-megamenu-toggle');
                            if (iconButton.getAttribute('aria-expanded') === 'false') {
                                header.showMegaMenu(ref);
                            } else {
                                header.hideMegaMenu(ref);
                            }
                        }
                    });
                });
            },
            closeMegaMenuOnClick: () => {
                const overlay = document.getElementById("megamenu_overlay");
                if (!overlay) return;

                overlay.addEventListener("click", () => {
                    const menu = document.querySelector(".header__link--wrapper.active");

                    header.hideMegaMenu(menu);
                });
            },
            toggleMobileMenuItems: () => {
                const nav = document.getElementById("nav-list");

                if (nav !== null) {
                    const items = nav.querySelectorAll("li");

                    items.forEach((item) => {
                        item.addEventListener("click", (e) => {
                            e.stopPropagation();
                            const parent = e.target.closest("li");

                            const elem = parent.querySelector(".header__sub--wrapper");

                            if (elem !== null) {
                                if (parent.classList.contains("active")) {
                                    parent.classList.remove("active");
                                    elem.style.display = "none";
                                } else {
                                    parent.classList.add("active");
                                    elem.style.display = "block";
                                }
                            }
                            e.stopImmediatePropagation();
                        });
                    });
                }
            },
            OpenContryselectorPopup: () => {
                const panel = document.getElementById("country-selector");
                const openPopup = document.getElementById("OpenCountrySelector");
                if (openPopup != null && openPopup.value == "1") {
                    panel.classList.add("active");
                    panel.setAttribute("aria-expanded", "true");
                    header.store.languagePanelIsExpanded = true;
                }
            },
            hideMenuOnScroll: () => {
                const menuItem = document.getElementsByClassName("js-header")[0];
                const menuBottom = menuItem.querySelector(".js-header-bottom");
                const background = document.getElementById("megamenu_background")
                let previousPosition = window.pageYOffset;
                const SCROLL_THRESHOLD = 5;

                document.onscroll = function () {
                    const currentPosition = window.pageYOffset;
                    const delta = previousPosition - currentPosition; // positive = up, negative = down

                    if (Math.abs(delta) < SCROLL_THRESHOLD) {
                        return;
                    }

                    if (!header.store.megaMenuIsExpanded && menuBottom != null) {
                        if (document.querySelectorAll(".search--expanded").length < 1) {
                            if (
                                document.querySelectorAll(".menu__mobile--expanded").length < 1
                            ) {
                                if (currentPosition > 63) {
                                    //Scrolling up
                                    if (delta > 0) {
                                        if (menuBottom != null) {
                                            menuBottom.style.height = "63px";
                                            menuBottom.style.overflow = "initial";
                                            background.style.display = "block";
                                        }
                                    }

                                    //Scrolling down
                                    else {
                                        const langSwitchButton =
                                            document.getElementById("button__language");
                                        if (menuBottom != null) {
                                            background.style.display = "none";
                                            menuBottom.style.height = "0px";
                                            menuBottom.style.overflow = "hidden";
                                        }

                                        if (langSwitchButton !== null) {
                                            if (langSwitchButton.classList.contains("active")) {
                                                langSwitchButton.classList.remove("active");
                                            }
                                        }
                                    }
                                    previousPosition = currentPosition;
                                }

                                if (currentPosition > 0 && currentPosition < 64) {
                                    //Scrolling up
                                    if (delta > 0) {
                                        if (menuBottom != null) {
                                            menuBottom.style.height = "63px";
                                            menuBottom.style.overflow = "initial";
                                            background.style.display = "block";
                                        }
                                    }
                                    previousPosition = currentPosition;
                                }
                            }
                        }
                    }
                };
            },
            toggleMobileMenu: () => {
                const menuButton = document.querySelectorAll(
                    ".js-toggle-mobile-menu"
                )[0];
                const body = document.getElementsByTagName("body")[0];
                const mainLinks = document.querySelectorAll(".js-megamenu-toggle");

                if (menuButton !== undefined) {
                    menuButton.addEventListener("click", (e) => {
                        const navListItems = document.querySelectorAll(
                            "#nav-list li.active"
                        );

                        body.classList.toggle("menu__mobile--expanded");

                        if (!body.classList.contains(".menu__mobile--expanded")) {
                            navListItems.forEach((navListItem) => {
                                navListItem.classList.remove("active");
                                const x = navListItem.querySelector(".header__sub--wrapper");

                                if (x !== null) {
                                    x.style.display = "none";
                                }
                            });
                        }

                        body.classList.remove("megamenu__expanded");

                        mainLinks.forEach((mainLink) => {
                            mainLink.classList.remove("active");
                        });
                        e.stopImmediatePropagation();
                    });
                }
            },
            detectActiveTopLink: () => {
                const selectedItemLink = document.querySelector(
                    ".js-megamenu-toggle.selected"
                );
                if (selectedItemLink != null) {
                    selectedItemLink.classList.add("top-active");
                }
            },
            toogleQuickLanguageSelect: () => {
                const buttons = document.querySelectorAll(".js-button-toggle");
                if (buttons !== null) {
                    buttons.forEach((button) => {
                        button.addEventListener("click", (e) => {
                            const list = e.target.nextElementSibling;

                            if (list !== null) {
                                e.target.classList.toggle("active");

                                if (e.target.classList.contains("active")) {
                                    list.setAttribute("aria-expanded", "true");
                                } else {
                                    list.setAttribute("aria-expanded", "false");
                                }
                            }
                        });
                    });
                }
            },
            registerResize: () => {
                window.addEventListener("resize", header.onResize);
            },
            navigateLanguage: () => {
                const buttons = document.querySelectorAll(".js-lang-switch");

                buttons.forEach((button) => {
                    button.addEventListener("click", function (e) {
                        if (e.target.dataset.code != null) {
                            // Set the language preference cookie before navigating
                            cookie.setCookie("securitas_lang_pref", e.target.dataset.code, 365);

                            fetch(`/api/countries/GetPageFor/?urlRequest=${encodeURIComponent(window.location.href)}&langCode=${e.target.dataset.code}`)
                                .then((response) => {
                                    if (!response.ok) {
                                        throw new Error(`HTTP error! status: ${response.status}`);
                                    }
                                    return response.text();
                                })
                                .then((data) => {
                                    try {
                                        window.location.href = data;
                                    } catch (error) {
                                        console.error("Failed to parse JSON:", error);
                                    }
                                })
                                .catch((error) => {
                                    console.error(error);
                                });
                        }
                    });
                });
            },
            triggerPhonePanel: () => {
                const phoneTrigger = document.querySelector(".js-trigger-phone");
                const phonePanelClose = document.querySelector(".js-phone-panel-close");
                const parentWrapper = document.querySelector(".js-col");

                if (phoneTrigger !== null) {
                    phoneTrigger.addEventListener("click", () => {
                        parentWrapper.classList.add("phone-expanded");
                    });
                }

                if (phonePanelClose !== null) {
                    phonePanelClose.addEventListener("click", () => {
                        parentWrapper.classList.remove("phone-expanded");
                    });
                }
            },
            changeChevronDownColor: () => {
                const isMobile = window.matchMedia("(max-width: 767px)").matches;
                const svgs = document.querySelectorAll(
                    ".js-megamenu-toggle .link__inner svg use"
                );

                svgs.forEach((svg) => {
                    if (isMobile) {
                        svg.closest("svg").classList.add("svg-menu");
                    }

                    svg.setAttribute(
                        "xlink:href",
                        isMobile
                            ? "/images/securitas.spritemap.svg#sprite-chevron-right--blue" // Mobile version
                            : "/images/securitas.spritemap.svg#sprite-chevron-down--white"
                    ); // Desktop version
                });
            },
            expandMobileMegaMenu: () => {
                const menuItems = document.querySelectorAll(".js-megamenu-toggle");
                header.removePresetClasses(menuItems);

                menuItems.forEach((item) => {
                    const languangeItem = document.querySelector(".cta__linkmobile")
                    item.querySelector(".svg-menu")?.addEventListener("touchend", function (event) {
                        event.preventDefault();
                        event.stopPropagation();
                        const isActive = item.classList.contains("active");
                        if (event.target.closest("span").classList.contains("link__inner")) {
                            if (!isActive) {
                                languangeItem.style.display = "none";
                                item.classList.add("megamenu-mobile-submenu");
                                item.classList.add("active");
                                item
                                    .querySelectorAll(".header__sub--wrapper")
                                    .forEach((item) => {
                                        item.classList.add("expanded-mega-menu");
                                    });
                                menuItems.forEach((otherItem) => {
                                    if (otherItem !== item) {
                                        otherItem.style.display = "none";
                                    }
                                });
                            } else if (isActive) {
                                item.classList.remove("megamenu-mobile-submenu");
                                languangeItem.style.display = "block";
                                item.classList.remove("active");
                                item
                                    .querySelectorAll(".header__sub--wrapper")
                                    .forEach((item) => {
                                        item.classList.remove("expanded-mega-menu");
                                    });
                                menuItems.forEach((otherItem) => {
                                    otherItem.style.display = "block";
                                });
                            }
                        }
                    });
                });
            },
        };
        const abbrTags = document.getElementsByTagName("abbr");
        if (abbrTags.length > 0) {
            for (const tag of abbrTags) {
                const array = tag.textContent.split(":");
                if (array.length > 1 && typeof array[1] !== "undefined") {
                    tag.textContent = array[0]; // text:title
                }
            }
        }

        header.init();
    }
})();
